import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Grid,
  Switch,
  FormControlLabel,
  Button,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";

function getCSRFToken() {
  const name = "csrftoken";
  const cookies = document.cookie.split(";");
  for (let c of cookies) {
    const t = c.trim();
    if (t.startsWith(name + "="))
      return decodeURIComponent(t.substring(name.length + 1));
  }
  return null;
}

const Club = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [puntos, setPuntos] = useState("");
  const [estado, setEstado] = useState(true);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    type: "error",
    message: "",
  });

  useEffect(() => {
    const fetchCode = async () => {
      const r = await fetch("/servicios/next-producto-club-code/", {
        credentials: "include",
      });
      const d = await r.json();
      if (d.next_code) setCode(d.next_code);
    };
    fetchCode();
  }, []);

  const handleLogout = async () => {
    await fetch("/sistema/logout/", { method: "POST", credentials: "include" });
    localStorage.clear();
    navigate("/login");
  };

  const handleSelect = (component) => {
    if (component === "AdminSection") navigate("/admin-panel/secciones");
    else if (component === "ModalInventario") setSubmenuOpen((s) => !s);
    else if (component === "AdminProduct") navigate("/admin-panel/inventario/productos");
    else if (component === "AdminVariant") navigate("/admin-panel/inventario/variantes");
    else if (component === "AdminServices") navigate("/admin-panel/servicios");
    else if (component === "AdminPromotion") navigate("/admin-panel/promociones");
    else navigate("/admin-panel");
  };

  const handleImageChange = (file) => {
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const removeImage = () => {
    setImage(null);
    setPreview(null);
  };

  const handleSubmit = async () => {
    const csrf = getCSRFToken();
    const formData = new FormData();

    formData.append("name", name);
    formData.append("puntos", puntos);
    formData.append("estado", estado ? "activo" : "inactivo");
    if (image) formData.append("image", image);

    try {
      const r = await fetch("/servicios/crear-producto-club/", {
        method: "POST",
        credentials: "include",
        headers: csrf ? { "X-CSRFToken": csrf } : undefined,
        body: formData,
      });

      if (r.ok) {
        navigate("/admin-panel/productoclub", {
          state: {
            snackbar: {
              type: "success",
              message: "Producto del club creado exitosamente",
            },
          },
          replace: true,
        });
      } else {
        setSnackbar({
          open: true,
          type: "error",
          message: "Error al crear el producto",
        });
      }
    } catch {
      setSnackbar({
        open: true,
        type: "error",
        message: "Error de conexión con el servidor",
      });
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#edf0f7ff" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        handleSelect={handleSelect}
        handleLogout={handleLogout}
        navigate={navigate}
      />

      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />

        <Box sx={{ width: "95%", mx: "auto", mt: 3 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            sx={{
              textTransform: "none",
              bgcolor: "#1565C0",
              "&:hover": { bgcolor: "#0D47A1" },
              mb: 3,
            }}
            onClick={() => navigate(-1)}
          >
            Regresar
          </Button>

          <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1565C0" }}>
              Información del Producto Club
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Nombre del Producto"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Código"
                  value={code}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={estado}
                      onChange={(e) => setEstado(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={estado ? "Activo" : "Inactivo"}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Puntos requeridos"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={puntos}
                  onChange={(e) =>
                    setPuntos(e.target.value.replace(/\D/g, ""))
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                {!preview ? (
                  <Button
                    variant="outlined"
                    component="label"
                    sx={{ height: "56px", width: "100%" }}
                  >
                    Subir Imagen
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={(e) => handleImageChange(e.target.files[0])}
                    />
                  </Button>
                ) : (
                  <Box sx={{ textAlign: "center" }}>
                    <img
                      src={preview}
                      alt="Vista previa"
                      style={{
                        maxHeight: 150,
                        borderRadius: 8,
                        marginBottom: 8,
                      }}
                    />
                    <Box>
                      <IconButton color="error" onClick={removeImage}>
                        <DeleteIcon />
                      </IconButton>
                      <Button component="label" size="small">
                        Cambiar
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(e.target.files[0])
                          }
                        />
                      </Button>
                    </Box>
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} textAlign="center">
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    bgcolor: "#1565C0",
                    "&:hover": { bgcolor: "#0D47A1" },
                    mt: 2,
                  }}
                  onClick={handleSubmit}
                >
                  Crear Producto Club
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.type}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Club;
